import React, { useEffect, useState } from 'react';
import * as S from './styles';
import imgTriangle1 from './img/vitor-paris.png'
import imgTriangle2 from './img/vitor-escritorio.png'
import imgTriangle3 from './img/vitor-lamborghini.png'
import imgCeo from './img/vitor-ceo.png'
import imgLogoFutscore from './img/futlogo.png'
import IPhoneComponent from '@/components/IPhone';
import SectionIphoneComponent from './components/SectionIphone';
import TestimonialsSection from './components/TestemonialsSection';
import { BsTelegram } from 'react-icons/bs';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { IoAddOutline, IoConstruct, IoContrast } from 'react-icons/io5';

import { RiTelegramLine } from 'react-icons/ri';
import TelegramSection from './components/SectionTelegram';
import { useNavigate } from 'react-router-dom';

const LandingPage1: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [activeItem, setActiveItem] = useState(0);

  const navigate = useNavigate()

  const handleButton = () => {
    navigate("/register?af=1")
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep(prevStep => (prevStep === 9 ? 0 : prevStep + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveItem(prevItem => {
        return prevItem === 2 ? 0 : prevItem + 1;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <S.SectionPictures>
        <ul className='ig'>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
          <li>@vitor.kawano</li>
        </ul>
        <div className="row-primary">
          <div className="col-cta">
            <div className="cta-primary">
              <img className='fut-logo' src={imgLogoFutscore} alt="" />
              <br />
              <h1>Transforme sua vida financeira com o poder da <b className='text-green'>INTELIGÊNCIA ARTIFICIAL</b> </h1>
            </div>
            <div className="cta-secondary">
              <p></p>
              <br />
              <p>Aprenda a ganhar dinheiro de maneira sustentável com nosso software inovador chamado  <b>Futscore</b>.</p>
              <br />
              <p>
                Além de ganhar acesso ao grupo vip com o <b>Vitor Kawano</b>,
                você irá ganhar um treinamento gratuito diretamente com ele.

              </p>
            </div>
            <div className="cta-action">
              <S.StyledButton onClick={() => handleButton()} >FAZER LOGIN GRATUITO</S.StyledButton>
            </div>
          </div>
          <div className="col-images">
            <S.StyledImage
              className={`item item1 ${activeItem === 0 ? 'active' : ''}`}
              src={imgTriangle1}
              alt="Vitor Kawano Escritório"
            />
            <S.StyledImage
              className={`item item2 ${activeItem === 1 ? 'active' : ''}`}
              src={imgTriangle2}
              alt="Vitor Kawano Escritório"
            />
            <S.StyledImage
              className={`item item3 ${activeItem === 2 ? 'active' : ''}`}
              src={imgTriangle3}
              alt="Vitor Kawano Escritório"
            />
            <div className="asset"></div>
          </div>
        </div>
      </S.SectionPictures>

      <SectionIphoneComponent />
      <TestimonialsSection />



      <TelegramSection />

      <S.SectionCeo>
        <div className="row-primary">
          <div className="col-ceo">
            <h1>QUEM É <b>VITOR KAWANO</b>?</h1>
            <br />
            <br />
            <img src={imgCeo} alt="" />
          </div>
          <div className="col-cta">
            <p>Vitor Kawano é um entusiasta das apostas esportivas que decidiu transformar sua paixão em sua profissão. Com uma abordagem dedicada e estratégica, ele deixou para trás o mundo corporativo tradicional para buscar uma vida mais emocionante e recompensadora.</p>
            <br />
            <p>Iniciando sua jornada em 2020, Vitor mergulhou fundo no universo das apostas esportivas, adquirindo conhecimento e habilidades ao longo do caminho. Sua determinação e habilidade para identificar padrões e tendências nos jogos o levaram a grandes sucessos financeiros.
            </p>
            <br />
            <p>
              Com o tempo, Vitor se tornou uma autoridade respeitada nesse mercado, compartilhando sua experiência e insights através de um software inovador que ele desenvolveu. Esse software não apenas auxilia os entusiastas das apostas a tomarem decisões mais informadas, mas também solidifica a reputação de Vitor como um dos principais especialistas em apostas esportivas da atualidade.
            </p>
          </div>

        </div>
      </S.SectionCeo>

      <S.SectionFaq>
        <div className="row-primary">
          <div className="col-cta">
            <h1>PERGUNTAS <b>FREQUENTES</b></h1>
            <p>
              Descubra respostas para suas dúvidas mais comuns de uma maneira interativa <br /> e amigável! Basta clicar nas perguntas para revelar as respostas e encontrar as informações que você procura de forma rápida e simples.
            </p>
            <div className="accordion">
              <Accordion>
                <AccordionSummary expandIcon={<IoAddOutline />}>
                  <h3>O Futscore é gratuito ou pago?</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>O Futscore é um software pago. Ele oferece diferentes planos de assinatura para atender às necessidades dos usuários.</p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<IoAddOutline />}>
                  <h3>Como posso contatar o suporte do Futscore em caso de dúvidas ou problemas?</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>Você pode contatar o suporte do Futscore através do nosso WhatsApp de suporte fornecido no site oficial. A equipe de suporte está disponível para ajudar com quaisquer dúvidas ou problemas que você possa ter.</p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<IoAddOutline />}>
                  <h3>Existe alguma forma de pagamento além de cartão de crédito?</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>Além do cartão de crédito, o Futscore pode oferecer o pix, como um método de pagamento online.</p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<IoAddOutline />}>
                  <h3>Qual é a política de reembolso do Futscore?</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>Se não ficar totalmente satisfeito(a) com o produto, devolvemos seu dinheiro. Entre em contato conosco dentro de 7 dias após a compra.</p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<IoAddOutline />}>
                  <h3>O Futscore é constantemente atualizado com novos recursos e melhorias?</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>Sim, a equipe por trás do Futscore trabalha constantemente para melhorar o software, oferecendo novos recursos e melhorias para garantir a melhor experiência possível aos usuários.</p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<IoAddOutline />}>
                  <h3>Como posso garantir a segurança dos meus dados ao usar o Futscore?</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p>O Futscore adota medidas de segurança para proteger os dados dos usuários, como criptografia de dados e políticas de privacidade robustas. É importante seguir as diretrizes de segurança recomendadas ao usar o software.</p>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <div className="col-phone">
            {/* <img src={imgPhone} alt="" /> */}
          </div>
          {/* <button>ACESSAR GRUPO GRATUITO</button> */}
        </div>
      </S.SectionFaq>

      <S.Footer>
        <ul>
          <li>VITOR KAWANO</li>
          <li>TODOS DIREITOS RESERVADOS</li>
          <li>2024</li>
        </ul>
      </S.Footer>
    </>
  );
};

export default LandingPage1;
